import { Utils } from 'mw-style-react';

// COMMON
export const CONFIG = Utils.createRequestTypes('CONFIG');
export const APP_AUTH_START = Utils.createRequestTypes('APP_AUTH_START');
export const AUTH = Utils.createRequestTypes('AUTH');
export const SET_TAB_ID = Utils.createRequestTypes('SET_TAB_ID');

export const LOGOUT = Utils.createRequestTypes('LOGOUT');
export const GET_USERS = Utils.createRequestTypes('GET_USERS');
export const SHOW_NOTIFY = Utils.createRequestTypes('SHOW_NOTIFY');
export const HIDE_NOTIFY = Utils.createRequestTypes('HIDE_NOTIFY');
export const SET_THEME = Utils.createRequestTypes('SET_THEME');
export const REQUEST_ACCESS = Utils.createRequestTypes('REQUEST_ACCESS');
export const SEND_INVITE = Utils.createRequestTypes('SEND_INVITE');
export const ACCOUNTS = Utils.createRequestTypes('ACCOUNTS');
export const ACCOUNT_CREATE = Utils.createRequestTypes('ACCOUNT_CREATE');
export const ACCOUNT_UPDATE = Utils.createRequestTypes('ACCOUNT_UPDATE');
export const ACCOUNT_DELETE = Utils.createRequestTypes('ACCOUNT_DELETE');
export const SUPPORT_SEND = Utils.createRequestTypes('SUPPORT_SEND');
export const CHANGE_USER_ACCESS_LEVEL = Utils.createRequestTypes(
  'CHANGE_USER_ACCESS_LEVEL'
);
export const REMOVE_USER = Utils.createRequestTypes('REMOVE_USER');
export const IMPORT_EVENTS = Utils.createRequestTypes('IMPORT_EVENTS');
export const UPLOAD_FILE = Utils.createRequestTypes('UPLOAD_FILE');

// FILES
export const GET_FILES = Utils.createRequestTypes('GET_FILES');
export const STARRED_FILE = Utils.createRequestTypes('STARRED_FILE');
export const SEARCH_FILES = Utils.createRequestTypes('SEARCH_FILES');
export const CLEAR_FILES = 'CLEAR_FILES';
export const SET_FILES_REQ_STATUS = 'SET_FILES_REQ_STATUS';

// SEARCH
export const SEARCH = Utils.createRequestTypes('SEARCH');
export const RECENT = Utils.createRequestTypes('RECENT');
export const CLEAR_SEARCH = 'CLEAR_SEARCH';

// GRAPH
export const GET_COMPANY_GRAPH = Utils.createRequestTypes('GET_COMPANY_GRAPH');
export const SEARCH_GRAPH_ITEMS =
  Utils.createRequestTypes('SEARCH_GRAPH_ITEMS');
export const DEL_COMPANY_GRAPH = Utils.createRequestTypes('DEL_COMPANY_GRAPH');
export const GET_VERTEX_TYPES = Utils.createRequestTypes('GET_VERTEX_TYPES');
export const GET_USERS_RELATIONS = Utils.createRequestTypes(
  'GET_USERS_RELATIONS'
);
export const SET_COMPANY_GRAPH_REQ_STATUS = 'SET_COMPANY_GRAPH_REQ_STATUS';
export const CLEAR_COMPANY_GRAPH = 'CLEAR_COMPANY_GRAPH';

// CREDENTIALS
export const CREATE_CREDENTIAL = Utils.createRequestTypes('CREATE_CREDENTIAL');
export const UPDATE_CREDENTIAL = Utils.createRequestTypes('UPDATE_CREDENTIAL');
export const GET_CREDENTIALS = Utils.createRequestTypes('GET_CREDENTIALS');
export const DELETE_CREDENTIAL = Utils.createRequestTypes('DELETE_CREDENTIAL');
export const SET_CREDENTIALS_REQ_STATUS = 'SET_CREDENTIALS_REQ_STATUS';
export const CLEAR_CREDENTIALS = 'CLEAR_CREDENTIALS';

// WEBHOOKS
export const CREATE_WEBHOOK = Utils.createRequestTypes('CREATE_WEBHOOK');
export const UPDATE_WEBHOOK = Utils.createRequestTypes('UPDATE_WEBHOOK');
export const GET_WEBHOOKS = Utils.createRequestTypes('GET_WEBHOOKS');
export const DELETE_WEBHOOK = Utils.createRequestTypes('DELETE_WEBHOOK');
export const SET_WEBHOOKS_REQ_STATUS = 'SET_WEBHOOKS_REQ_STATUS';
export const CLEAR_WEBHOOKS = 'CLEAR_WEBHOOKS';

// ACCESS RULES
export const GET_ACCESS_RULES = Utils.createRequestTypes('GET_ACCESS_RULES');
export const MANAGE_ACCESS_RULES = Utils.createRequestTypes(
  'MANAGE_ACCESS_RULES'
);

// COMMON SINGLE
export const APP_AUTH_KEY = 'APP_AUTH_KEY';
export const APP_NAME = 'APP_NAME';
export const CHECK_SESSION = 'CHECK_SESSION';
export const CHECK_VERSION = 'CHECK_VERSION';
export const SHOW_VERSION_MODAL = 'SHOW_VERSION_MODAL';
export const SHOW_SESSION_MODAL = 'SHOW_SESSION_MODAL';
export const SET_MODAL = 'SET_MODAL';
export const SET_LOCATION = 'SET_LOCATION';
export const DEL_MODAL = 'DEL_MODAL';
export const SET_ACTIVE_ACC = 'SET_ACTIVE_ACC';
export const SET_NEW_ACC = 'SET_NEW_ACC';
export const SET_ACTIVE_EVENT = 'SET_ACTIVE_EVENT';
export const TO_REACTIONS = 'TO_REACTIONS';
export const CREATE_DELAYED_ACTION = 'CREATE_DELAYED_ACTION';
export const CLEAR_DELAYES_ACTION = 'CLEAR_DELAYES_ACTION';
export const CLEAR_NOTIFY = 'CLEAR_NOTIFY';

// WS EVENTS
export const WS_OPEN = 'WS_OPEN';
export const WS_RECONNECTION = 'WS_RECONNECTION';
export const WS_RECONNECTION_SUCCESS = 'WS_RECONNECTION_SUCCESS';
export const WS_CLOSE = 'WS_CLOSE';
export const WS_ERROR = 'WS_ERROR';
export const WS_SEND = 'WS_SEND';
export const WS_NEW_NOTIFY = 'WS_NEW_NOTIFY';
export const WS_CLEAR_NOTIFY = 'WS_CLEAR_NOTIFY';
export const WS_CLEAR_ACTOR_NOTIFY = 'WS_CLEAR_ACTOR_NOTIFY';
export const WS_NEW_USER = 'WS_NEW_USER';
export const WS_DELETE_USER = 'WS_DELETE_USER';
export const WS_UPDATE_USER = 'WS_UPDATE_USER';
export const WS_CREATE_ACCESS = 'WS_CREATE_ACCESS';
export const WS_UPDATE_ACCESS = 'WS_UPDATE_ACCESS';
export const WS_DELETE_ACCESS = 'WS_DELETE_ACCESS';

// postMessage actions
export const PM_START = 'PM_START';
export const PM_SEND = 'PM_SEND';
export const PM_INIT_OPTIONS = 'PM_INIT_OPTIONS';

// Electron
export const ELECTRON_NAVIGATE = 'ELECTRON_NAVIGATE';

export const NOTIFY_LEVEL = {
  SUCCESS: 'success',
  INFO: 'normal',
  WARNING: 'warning',
  ERROR: 'error',
};

export const DATE_FORMAT = 'm DD, YYYY; HH:mm';
export const DATE_FORMAT_1 = 'DD m HH:mm';
export const DATE_FORMAT_2 = 'DD m YYYY';
export const DATE_FORMAT_3 = 'YYYY/MM/DD HH:mm:ss';
export const DATE_FORMAT_4 = 'DD M YYYY, HH:mm';

export const STATUS = {
  new: 'new',
  deleted: 'deleted',
};

export const AccessLevel = Object.freeze({
  SIGN: 'sign',
  EXECUTE: 'execute',
  MODIFY: 'modify',
  VIEW: 'view',
  REMOVE: 'remove',
  RESULT: 'result',
});

export const RequestStatus = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  UNAUTH: 'unauth',
});

export const SCRIPT_SHARE_TYPES = [
  'userList',
  'allWorkspaceUsers',
  'allRegisteredUsers',
  'anyone',
];

export const ACCEPT_FILES =
  'image/*,text/*,application/*,video/*,audio/*,.xls,.sql,.doc,.docx,.odt,.rtf';
export const MOB_WINDOW_SIZE = 414;
export const TABLET_WINDOW_SIZE = 768;
export const DESKTOP_WINDOW_SIZE = 1024;
